
// import the interface
import { CrudProductAction, ProductTypeAction } from '../actions/product.action';
import { Product } from '../models/product.model';
import { cloneDeep } from 'lodash'
//create a dummy initial state
const initialState: Product[] = [];
export function productReducer(state: Product[] = initialState,action: CrudProductAction) {
  switch (action.type) {
    case ProductTypeAction.SAVE_PRODUCT:
        
        state=Object.assign([],state)
        state=state.concat(action.payload)
    
      return {
        ...state
      };

    default:
      return state;
  }
}
